(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.js-category-tabs').forEach(function (wrapper) {
    if (wrapper.dataset.dropdownInit) return; // don't run twice on the same element
    wrapper.dataset.dropdownInit = 'true';

    var tabs = Array.prototype.slice.call(wrapper.querySelectorAll('.category-tab'));
    if (!tabs.length) return;

    // Wrap the existing tabs in a list container (needed for the CSS to
    // show/hide them as a group on mobile)
    var list = document.createElement('div');
    list.className = 'category-tabs-list js-category-tabs-list';
    list.setAttribute('role', 'listbox');
    wrapper.insertBefore(list, tabs[0]);
    tabs.forEach(function (tab) { list.appendChild(tab); });

    // Build the trigger button
    var activeTab = wrapper.querySelector('.category-tab.active') || tabs[0];
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'category-tabs-toggle js-category-tabs-toggle';
    toggle.setAttribute('aria-haspopup', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML =
      '<span class="category-tabs-toggle-label">' + activeTab.textContent.trim() + '</span>' +
      '<svg class="category-tabs-toggle-caret" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>';
    wrapper.insertBefore(toggle, list);

    var label = toggle.querySelector('.category-tabs-toggle-label');

    function closeDropdown() {
      wrapper.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    function openDropdown() {
      wrapper.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      wrapper.classList.contains('is-open') ? closeDropdown() : openDropdown();
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        label.textContent = tab.textContent.trim();
        closeDropdown();
      });
    });

    document.addEventListener('click', function (e) {
      if (!wrapper.contains(e.target)) closeDropdown();
    });
  });
});







/** temp filter **/

/*document.addEventListener('DOMContentLoaded', function () {
  var tabsWrapper = document.querySelector('.js-category-tabs');
  var grid = document.querySelector('.product-loop');
  if (!tabsWrapper || !grid) return;

  var products = grid.querySelectorAll('.product-loop__item');

  function isBestSeller(product) {
    var badge = product.querySelector('.p_tag');
    // exact text match zaroori hai — .p_tag "Tea towel" jaise
    // dusre badges ke liye bhi use hota hai
    return !!badge && badge.textContent.trim().toLowerCase() === 'best seller';
  }

  tabsWrapper.addEventListener('click', function (e) {
    var tab = e.target.closest('.category-tab');
    if (!tab) return;
    e.preventDefault();

    var category = tab.textContent.trim().toLowerCase();

    products.forEach(function (product) {
      var show;

      if (category === 'best sellers') {
        show = isBestSeller(product);
      } else {
     
        show = true;
      }

      product.style.display = show ? '' : 'none';
    });
  });
});*/
$(function(){
  $(document).on('click', '.category-tab', function (e) {
  e.preventDefault();

  const $tab = $(this);
  const filter = $.trim($tab.text());

  // Active tab
  $('.category-tab').removeClass('active');
    $tab.addClass('active');

    $('.product-loop__item').each(function () {
      const $product = $(this);
      const productFilter = $.trim($product.attr('data-filter') || '');

      // Show all products
      if (filter.toLowerCase() === 'all products') {
        $product.show();
        return;
      }

      // Normalize text:
      // Best Sellers -> best seller
      // Crumble Toppings -> crumble topping
      const normalize = function (text) {
        return text
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .replace(/\bproducts\b/g, 'product')
          .replace(/\bsellers\b/g, 'seller')
          .replace(/\btoppings\b/g, 'topping')
          .trim();
      };

      const category = normalize(filter);
      const productCategories = normalize(productFilter);

      // Check if category exists inside data-filter
      const matched = productCategories.indexOf(category) !== -1;

      $product.toggle(matched);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  $(function(){
    console.log("Ready to go", $(".jm-review-widget-minimal-header__title").length);
    const titleInterval = setInterval(() => {
        if($(".jm-review-widget-minimal-header__title").length) {
            $(".jm-review-widget-minimal-header__title").text("Product Reviews");
          clearInterval(titleInterval);
        }
    }, 1000);

    function convertReviewDates() {
      $(".jm-reviewer-info__details .jm-text").each(function () {
        const $date = $(this);
        const dateText = $date.text().trim();

        const reviewDate = new Date(dateText);

        if (isNaN(reviewDate.getTime())) {
          return;
        }

        const today = new Date();

        // Reset time so we're comparing calendar days
        today.setHours(0, 0, 0, 0);
        reviewDate.setHours(0, 0, 0, 0);

        const diffDays = Math.floor(
          (today - reviewDate) / (1000 * 60 * 60 * 24)
        );

        let text;

        if (diffDays === 0) {
          text = "Today";
        } else if (diffDays === 1) {
          text = "1 day ago";
        } else if (diffDays < 30) {
          text = `${diffDays} days ago`;
        } else {
          const diffMonths = Math.floor(diffDays / 30);

          if (diffMonths === 1) {
            text = "1 month ago";
          } else {
            text = `${diffMonths} months ago`;
          }
        }

        $date.text(text);
      });
    }

    const interval = setInterval(function () {

        if ($(".jm-reviewer-info__details").length) {
          convertReviewDates();
          console.log("days ago length: ", $(".jm-reviewer-info__details").length);

          clearInterval(interval);
        }

      }, 1000);
    $(document).on("click", ".jm-pagination-controls__button--nav", function () {

      const interval = setInterval(function () {

        if ($(".jm-reviewer-info__details").length) {
          convertReviewDates();
          console.log("days ago length: ", $(".jm-reviewer-info__details").length);

          clearInterval(interval);
        }

      }, 100);

    });

    function equalizeRecipeContent() {
      $(".recipe-card h3, .recipe-card p").css("height", "auto");
      [".recipe-card h3", ".recipe-card p"].forEach(function (selector) {
        const $elements = $(selector);
        if (!$elements.length) {
          return;
        }
        let maxHeight = 0;
        $elements.each(function () {
          maxHeight = Math.max(maxHeight, $(this).outerHeight());
        });
        $elements.css("min-height", maxHeight + "px");
      });
    }
    equalizeRecipeContent();
    $(window).on("load", function () {
      equalizeRecipeContent();
    });
    let resizeTimer;
    $(window).on("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        equalizeRecipeContent();
      }, 150);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
